import { apiFetch } from './client.js';

export interface DashboardKycRecent {
  customerId: string;
  maskedName: string;
  displayName?: string;
  status: string;
  submittedAt: string;
}

export interface DashboardOverview {
  generatedAt: string;
  kyc: {
    active: number;
    pending: number;
    underReview: number;
    prohibited: number;
    total: number;
    recentSubmissions: DashboardKycRecent[];
  };
  accounts: {
    total: number;
    active: number;
    pending: number;
    byCurrency: { currency: string; count: number }[];
  };
  ledger: { settledTodayCents: string; currency: string };
  aml: { openAlerts: number };
  /** Money that has arrived and is waiting on somebody to release it. */
  inbound: { awaitingReview: number };
  reconciliation: { lastRun: { runDate: string; status: string; breakCents: string } | null };
  services: { name: string; slo: string; status: string }[];
}

export const dashboardApi = {
  overview: (): Promise<DashboardOverview> =>
    apiFetch<DashboardOverview>('/admin/dashboard/overview'),
};
